
import filters from "@/filters";
import { Component, Prop, Vue } from "vue-property-decorator";
import { CourseSectionEnum } from "@/constants/enum.constant";

@Component({
  components: {},
  filters,
})
export default class ModalRetakeTest extends Vue {
  @Prop({ default: null })
  private course!: any;
  @Prop({ default: CourseSectionEnum.PRE_TEST })
  private section!: number;

  private cancel() {
    this.$bvModal.hide("modal-retake-test");
  }

  private redirect() {
    this.$bvModal.hide("modal-retake-test");
    this.$router.push({
      name: "course-detail",
      params: {
        slug: this.course?.slug,
      },
    });
  }
}
